import {
  Clickable,
  Modal,
  ModalContent,
  ModalFooterButtons,
  ModalHeader,
} from "monday-ui-react-core";
import { useCallback, useEffect, useState } from "react";
import { isInsideIframe } from "../../services/utils";
import Classes from "./InstallButton.module.scss";

let installPrompt: any;

const InstallButton = () => {
  const insideIframe = isInsideIframe();
  const [installable, setInstallable] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showChromeIOS, setShowChromeIOS] = useState(false);
  const [showSafariIOS, setShowSafariIOS] = useState(false);

  const isChromeIOS = /crios/.test(window.navigator.userAgent.toLowerCase());

  const isIOS = /iphone|ipad|ipod/.test(
    window.navigator.userAgent.toLowerCase()
  );
  // Detects if device is in standalone mode
  const isInStandaloneMode = "standalone" in window.navigator;

  // Checks if should display install popup notification:

  useEffect(() => {
    if (isIOS && !isInStandaloneMode) {
      setInstallable(true);
      return;
    }

    window.addEventListener("beforeinstallprompt", (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      installPrompt = e;
      // Update UI notify the user they can install the PWA
      setInstallable(true);
    });

    window.addEventListener("appinstalled", () => {
      // Log install to analytics
      setInstallable(false);
      console.log("INSTALL: Success");
    });
  }, [isIOS, isInStandaloneMode]);

  const handleInstallClick = (e: any) => {
    if (isIOS) {
      if (isChromeIOS) {
        setShowChromeIOS(true);
      } else {
        setShowSafariIOS(true);
      }
      setShowModal(true);
      return;
    }

    // Show the install prompt
    installPrompt.prompt();
    // Wait for the user to respond to the prompt
    installPrompt.userChoice.then((choiceResult: any) => {
      if (choiceResult.outcome === "accepted") {
        setInstallable(false);
      } else {
        setInstallable(true);
      }
    });
  };

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  enum MobileDeviceType {
    CHROME_IOS = "chrome-ios",
    SAFARI_IOS = "safari-ios",
  }

  const getModalContent = (mobileDeviceType: MobileDeviceType) => {
    if (mobileDeviceType === MobileDeviceType.CHROME_IOS) {
      return (
        <div>
          <span>לחצו על האייקון </span>
          <img src={`share-chrome-ios.svg`} alt="שתף" />
          <span>
            {" "}
            שנמצא בחלקו העליון של המסך ולאחר מכן לחצו על הוסף למסך הבית
          </span>
        </div>
      );
    }
    return (
      <div>
        <span>לחצו על האייקון </span>
        <img src={`share-safari-ios.svg`} alt="שתף" />
        <span>
          {" "}
          שנמצא בחלקו התחתון של המסך ולאחר מכן לחצו על הוסף למסך הבית
        </span>
      </div>
    );
  };

  return (
    <div className={Classes.wrapper}>
      {!insideIframe && installable && (
        <Clickable className={Classes.button} onClick={handleInstallClick}>
          התקינו את המחשבון על מכשירכם
        </Clickable>
      )}
      {(showChromeIOS || showSafariIOS) && (
        <Modal
          show={showModal}
          onClose={closeModal}
          closeButtonAriaLabel={"סגור"}
          width={Modal.width.DEFAULT}
          data-testid="bla"
        >
          <ModalHeader title={"הוראות התקנה"} hideCloseButton />

          <ModalContent>
            {getModalContent(
              showChromeIOS
                ? MobileDeviceType.CHROME_IOS
                : MobileDeviceType.SAFARI_IOS
            )}
          </ModalContent>
          <ModalFooterButtons
            primaryButtonText="הבנתי"
            secondaryButtonText="בטל"
            onPrimaryButtonClick={closeModal}
            onSecondaryButtonClick={closeModal}
          />
        </Modal>
      )}
    </div>
  );
};

export default InstallButton;
